import React from 'react';
import {observer} from 'mobx-react';
import s from '../../s';
import ModalSimple from '../../../global/modal-simple';
import {getPhoneHREF, Portal} from '../../../util';

/** "Need a frame matching a different document size?" (modal-doc-size-diff): the "Different Size?" link of both product page layouts. */
const DocSizeDiffModal: React.FC = observer(() => (
    <ModalSimple
        id="modal-doc-size-diff"
        title={`Need a frame matching a different ${s.ui.doc_type.toLowerCase()} size?`}
    >
        <div>
            <p>All of our frames are custom made to order so we can very easily create a frame that fits your specific Document size.</p>
            <p>
                Please call our customer service department at <a href={getPhoneHREF()}>{Portal?.CustomerServicePhone}</a> or email <a href={`mailto:${Portal?.CustomerServiceEmail}`}>{Portal?.CustomerServiceEmail}</a> and provide the Item # of the frame you would like to purchase along with any
                customizations and the size and orientation of your Document.
            </p>
            <p>We will provide a price and answer any questions you may have about this custom frame.</p>
        </div>
    </ModalSimple>
));

export default DocSizeDiffModal;
